import React from 'react'
import { Button } from '../Button'
import { ReactComponent as CloseSVG } from "assets/icons/exit.svg";
import styled from 'styled-components';

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 15px;
`

const Close = ({ onClick }) => {
  return (
    <Container>
      <Button onClick={onClick}>
        <CloseSVG height={30} width={30} />
      </Button>
    </Container>
  )
}

export default Close